document.addEventListener( 'DOMContentLoaded', () => {
	const sliders = document.querySelectorAll( '.logo-marquee.splide' );

	if ( sliders.length === 0 ) return;

	// Helper: Load Splide JS from CDN if not already present
	function loadSplide( callback ) {
		// If Splide is already loaded globally, run callback immediately
		if ( window.Splide ) {
			callback();
			return;
		}

		// If we are already loading it (prevent duplicate downloads)
		if ( window.splideScriptLoading ) {
			window.addEventListener( 'splideLoaded', callback );
			return;
		}

		window.splideScriptLoading = true;

		const script = document.createElement( 'script' );
		script.src =
			'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
		script.onload = () => {
			window.splideScriptLoading = false;
			// Dispatch event so other waiting blocks know it's ready
			window.dispatchEvent( new Event( 'splideLoaded' ) );
			callback();
		};
		document.head.appendChild( script );

		// Listener for the very first loader
		window.addEventListener( 'splideLoaded', callback );
	}

	// Main Execution
	loadSplide( () => {
		sliders.forEach( ( sliderElement ) => {
			// Check if already initialized to prevent double-init
			if ( sliderElement.classList.contains( 'is-initialized' ) ) return;

			const splide = new Splide( sliderElement, {
				type: 'loop',
				autoplay: true,
				interval: 5000,
				pauseOnHover: true,
				pauseOnFocus: true,
				perPage: 5,
				arrows: false,
				pagination: false,
				perMove: 1,
				gap: '2px',
				breakpoints: {
					992: { perPage: 3 },
					640: { perPage: 1 },
				},
			} );

			splide.mount();
			sliderElement.classList.add( 'is-initialized' );
		} );
	} );
} );
